module.exports = __webpack_public_path__ + "img/image.33a57f38.svg";